import FileItem from './FileItem';
import './style/index.less';

export default FileItem;
